module.exports = "<div class=\"hp-inner-center project-submitted-walkthrough\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12\">\n\t\t    <h1 class=\"walkthrough-header\">Your project is under review by our Specialist, and if approved, you should receive a disbursement date within 1 business day.</h1>\n\t\t</div>\n\t</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/appDetail/walkthrough/getPaid/projectCloserAcceptedTemplate.html
// module id = 659
// module chunks = 1